export default "__VITE_ASSET__C73qk1e7__"